<template lang="html">
  <div class="__menu-bottom">
    <v-container fluid class="pa-0">
      <v-row class="ma-0">
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
          <div class="__item-cart primary">
            <div class="d-flex">
              <div class="__item-in-cart">
                <span class="__item-count">{{ qtyincart }} item</span>
                <span v-mask-money="price" class="__item-price" />
              </div>
              <div class="spacer" />
              <v-btn type="submit" class="text-none" @click="goNext">
                Next
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog.min_order" max-width="320">
      <v-card>
        <v-card-text class="pt-8">
          <div class="mb-6">
            <v-img src="@/assets/images/svg/reserve_min_order.svg" width="166" height="166" class="mx-auto" />
          </div>
          <div class="text-center">
            <div class="title-dialog mx-3">
              Minimal order belum terpenuhi :(
            </div>
            <div class="subtitle-dialog mt-4">
              Pastikan orderanmu tidak kurang dari minimal order.
            </div>
          </div>
          <v-btn block large depressed color="primary" class="text-none mt-6" @click="dialog.min_order = false">
            Ya, saya mengerti
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ItemCart',
  props: {
    qtyincart: {
      required: true,
      type: Number
    },
    price: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      dialog: {
        min_order: false
      }
    }
  },
  methods: {
    goNext() {
      if (this.$store.state.selected_type === 'DELIVERY') {
        this.$router.push({ name: 'delivery_method' }).catch(() => {})
      } else if (this.$store.state.selected_type === 'RESERVATION') {
        if (!this.$isEmpty(this.$store.state.selected_outlet)) {
          if (this.price >= this.$store.state.selected_outlet.reservation.minimum_order_amount) {
            this.$router.push({ name: 'checkout' }).catch(() => {})
          } else {
            this.dialog.min_order = true
          }
        }
      } else {
        this.$router.push({ name: 'checkout' }).catch(() => {})
      }
    }
  }
}
</script>
